/**
 * JavaScript implementation of the ProductInputType enum
 * This file mirrors the enum defined in types.d.ts
 */

//TODO: Typescritp: Properly type this to enum
export const ProductInputType = {
   Boolean: 'boolean',
   Integer: 'integer',
   Decimal: 'decimal',
}

// Export other enums and types as needed
export const coreProductType = {
   None: 'core0',
   Core: 'core1',
   Pro: 'core2',
   Elite: 'core3',
}

export const SFDealDeskType = {
   NewSaleHRISImplementation: 'New Sale HRIS Implementation',
   ExpansionSaleHRISImplementation: 'Expansion Sale HRIS Implementation',
   QuickStart: 'Quickstart',
   PayrollSaleHRISImplementation: 'Payroll Sale Implementation',
}
